export class DealTermModel{    
    id: number;
    dealID:number;
    description :string;
    isBold :boolean;
}


// WEBPACK FOOTER //
// ./src/app/_models/deal-term.model.ts